<template>
  <div class="logo-container">
    <img :src="logoSrc" :alt="`${brandName} Logo`" class="logo-image" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useBranding } from '@/composables/useBranding';
import { useThemeScheme } from '@/composables/useThemeSchema';

const props = defineProps({
  isDark: Boolean,
  variant: {
    type: String,
    default: 'main',
  },
});

const { brandName, logo } = useBranding();
const { isDarkMode } = useThemeScheme();

const shouldUseDarkLogo = computed(() => (
  typeof props.isDark === 'boolean' ? props.isDark : isDarkMode.value
));

const logoSrc = computed(() => {
  if (props.variant === 'icon') {
    return shouldUseDarkLogo.value ? (logo.iconDark || logo.icon) : (logo.icon || logo.main);
  }

  return shouldUseDarkLogo.value
    ? (logo.mainDark || logo.main || logo.iconDark || logo.icon)
    : (logo.main || logo.icon);
});
</script>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  gap: 8px;
  width: 100%;
}

.logo-image {
  height: 70px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}
</style>
